import { Icon24Desktop } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const MonitorIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <rect
        x="1.875"
        y="2.5"
        width="16.25"
        height="11.25"
        rx="1.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.875 17.5H13.125" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M10 13.75V17.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
};

export const MonitorIcon = fplIcon(MonitorIconLocal, Icon24Desktop);
